import { render, staticRenderFns } from "./CalendarioService.vue?vue&type=template&id=0b826539&scoped=true"
import script from "./CalendarioService.vue?vue&type=script&lang=js"
export * from "./CalendarioService.vue?vue&type=script&lang=js"
import style0 from "./CalendarioService.vue?vue&type=style&index=0&id=0b826539&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b826539",
  null
  
)

export default component.exports